import { FC } from "react";

import { PostMatchSurveyMolecule } from "../../molecules"
import logoUppiness from "../../../assets/icons/logoUppiness.svg"
import { CornerCirclesBackground } from "../../atoms";

const PostMatchSurvey: FC<{}> = () => {

    return (
        <CornerCirclesBackground>
            <div className="form_wrapper">
                <img className="uppiness_logo" src={logoUppiness} alt="Uppiness Logo" />
                <div className="log_in_molecule_wrapper">
                    <PostMatchSurveyMolecule />
                </div>
            </div>
        </CornerCirclesBackground>
    );
}

export default PostMatchSurvey;